// 演出相关接口
import request from '@/utils/request'

// 演出视频详情接口
export function showVideoDetails(id) {
  return request({
    url: `/cultureCantonDemoApi/showVideoApi/getShowVideDetails?id=${id}`,
    method: 'get',
  })
}

// 演出视频观看记录保存
export function saveWatchLog(data) {
  return request({
    url: '/cultureCantonDemoApi/publicWatchLogApi/saveWatchLog',
    method: 'post',
    data,
  })
}
